import type { ReactNode } from 'react';

import { Menu } from 'lucide-react';
import { useState, useEffect } from 'react';

import { cn } from '@shared/utils/cn';
import { Button } from '@shared/components/ui/button';
import { PageHeaderSlot } from '@shared/components/page-header';

type Props = {
  onOpenMenu: () => void;
  children: ReactNode;
};

/** Sticky header: menu button below `lg`, page title + breadcrumb slot, actions on the right, blurred background once the page is scrolled. */
export const Header = ({ onOpenMenu, children }: Props) => {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 0);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <header
      className={cn(
        'sticky top-0 z-[1101] flex h-16 items-center px-4 transition-colors lg:h-18 lg:px-10',
        scrolled && 'border-b border-border/60 bg-canvas/80 backdrop-blur-sm'
      )}
      data-slot="header"
    >
      <Button
        aria-label="Ouvrir le menu"
        className="mr-2 -ml-2 lg:hidden"
        onClick={onOpenMenu}
        size="icon"
        variant="ghost"
      >
        <Menu className="size-6" />
      </Button>
      <PageHeaderSlot className="mr-2" />
      {children}
    </header>
  );
};
